/** @jsxImportSource @emotion/react */

import { Button } from '@mui/material'
import { FC } from 'react'
import { Form as FinalForm } from 'react-final-form'
import { useMutation } from '@apollo/client'
import TextareaAutosize from 'components/TextareaAutosize/TextareaAutosize'
import { UPDATE_GAME_CHALLENGE } from 'queries/gameChallenges'
import { updateGameChallenge, updateGameChallengeVariables } from '__generatedTypes__/updateGameChallenge'
import { validateRequired } from 'utils/validation'
import { toast } from 'utils/toast'
import * as classes from './styles'

type FormValues = {
  description: string
}

type Props = {
  gameId: string
  initialValues: FormValues
}

export const Form: FC<Props> = ({ gameId, initialValues }) => {
  const [updateGame, { loading }] = useMutation<updateGameChallenge, updateGameChallengeVariables>(
    UPDATE_GAME_CHALLENGE
  )

  const handleSubmit = async (values: FormValues) => {
    try {
      await updateGame({
        variables: {
          updateGameChallengeInputFieldName: {
            id: gameId,
            description: values.description,
          },
        },
      })

      toast.success('Game challenge description updated successfully')
    } catch (error) {
      toast.error('Failed to update game challenge description')
    }
  }

  return (
    <FinalForm<FormValues>
      onSubmit={handleSubmit}
      initialValues={initialValues}
      render={({ handleSubmit, dirty }) => (
        <form onSubmit={handleSubmit} css={classes.form} data-testid="edit-game-challenge-form">
          <TextareaAutosize
            name="description"
            label="Description"
            css={classes.textarea}
            validate={validateRequired}
            data-testid="description-field"
          />

          <Button color="blue" type="submit" size="large" disabled={!dirty || loading} data-testid="save-edits-button">
            Save Edits
          </Button>
        </form>
      )}
    />
  )
}
